// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Reaction (Color Confusion) Game Styles
 * Premium Modern Edition
 */

/* --- Game Arena --- */
.color-game-arena {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.24);
  backdrop-filter: blur(12px);
  margin-top: 16px;
}

.arena-stats {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  color: #86efac; /* Emerald-300 */
}

.arena-stats div {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* --- Prompt Section --- */
.prompt-container {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.prompt-word {
  font-size: 3.5rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
  /* Animated subtle pulse */
  animation: prompt-pulse 1.5s infinite;
  display: flex;
  align-items: center;
  gap: 12px;
}

.trap-hint {
  font-size: 1.25rem;
  font-weight: 800;
  color: #fbbf24; /* Amber-400 */
  text-shadow: 0 0 10px rgba(251, 191, 36, 0.5);
  letter-spacing: 1px;
}

@keyframes prompt-pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.03); }
  100% { transform: scale(1); }
}

.prompt-ready {
  font-size: 2rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.6);
  font-style: italic;
}

/* --- Options Grid --- */
.options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
}

.option-btn {
  padding: 20px;
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: capitalize;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.option-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.option-btn:active:not(:disabled) {
  transform: scale(0.96);
}

.option-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* --- Start Button --- */
.start-btn {
  grid-column: span 2;
  padding: 18px;
  font-size: 1.25rem;
  font-weight: 800;
  letter-spacing: 1px;
  border-radius: 14px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: #fff;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.4);
}

.start-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6);
  filter: brightness(1.1);
}

.start-btn:active:not(:disabled) {
  transform: scale(0.98);
}

/* --- Lobby & Cards --- */
.match-card {
  transition: all 0.3s ease !important;
}

.match-card:hover {
  border-color: rgba(139, 92, 246, 0.4) !important;
  background: rgba(139, 92, 246, 0.05) !important;
}

.round-summary {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.round-summary h3 {
  margin: 0 0 10px 0;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
}

/* Responsive Tweaks */
@media (max-width: 480px) {
  .prompt-word {
    font-size: 2.5rem;
  }
  
  .option-btn {
    padding: 16px;
    font-size: 1rem;
  }
}

/* Match Page Overrides for Flappy classes to fit Reaction */
.flappy-page.reaction-duel {
  background: radial-gradient(1200px 700px at 20% 10%, rgba(139, 92, 246, 0.15), transparent 55%),
              radial-gradient(900px 600px at 90% 0%, rgba(59, 130, 246, 0.15), transparent 55%),
              #060912;
}

.flappy-card h2 {
    color: #a78bfa;
}

/* Lobby Styling */
.reaction-lobby {
    background: radial-gradient(1200px 700px at 80% 90%, rgba(139, 92, 246, 0.12), transparent 55%),
                radial-gradient(900px 600px at 10% 10%, rgba(59, 130, 246, 0.12), transparent 55%),
                #080b16 !important;
}

.reaction-lobby .page-title {
    color: #a78bfa !important;
    text-shadow: 0 0 15px rgba(167, 139, 250, 0.3) !important;
}

/* Player Badges & Stats */
.player-badge {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
}

.player-name {
    font-weight: 700;
    color: #fff;
    font-size: 0.95rem;
}

.cm-player-stat {
    padding: 2px 8px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 800;
    text-transform: uppercase;
}

.cm-player-stat--rating {
    background: rgba(59, 130, 246, 0.2);
    color: #60a5fa;
}

.cm-player-stat--streak {
    background: rgba(234, 179, 8, 0.2);
    color: #facc15;
}

/* Background Orbs Animation */
.animated-bg {
    position: fixed;
    inset: 0;
    z-index: -1;
    overflow: hidden;
    pointer-events: none;
}

.gradient-orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.4;
}

.orb-1 {
    width: 400px;
    height: 400px;
    background: #4f46e5;
    top: -100px;
    left: -100px;
}

.orb-2 {
    width: 300px;
    height: 300px;
    background: #7c3aed;
    bottom: 50px;
    right: -50px;
}

.orb-3 {
    width: 250px;
    height: 250px;
    background: #db2777;
    top: 40%;
    left: 70%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Reaction.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc,EAAE,gBAAgB;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,4DAA4D;AAC5D;EACE;;qBAEmB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI;;kCAE8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,yDAAyD;AAC7D;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;AACb","sourcesContent":["/**\n * Reaction (Color Confusion) Game Styles\n * Premium Modern Edition\n */\n\n/* --- Game Arena --- */\n.color-game-arena {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  padding: 24px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.24);\n  backdrop-filter: blur(12px);\n  margin-top: 16px;\n}\n\n.arena-stats {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12px 20px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 12px;\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  color: #86efac; /* Emerald-300 */\n}\n\n.arena-stats div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* --- Prompt Section --- */\n.prompt-container {\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.prompt-word {\n  font-size: 3.5rem;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  text-shadow: 0 0 20px rgba(0, 0, 0, 0.4);\n  /* Animated subtle pulse */\n  animation: prompt-pulse 1.5s infinite;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.trap-hint {\n  font-size: 1.25rem;\n  font-weight: 800;\n  color: #fbbf24; /* Amber-400 */\n  text-shadow: 0 0 10px rgba(251, 191, 36, 0.5);\n  letter-spacing: 1px;\n}\n\n@keyframes prompt-pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.03); }\n  100% { transform: scale(1); }\n}\n\n.prompt-ready {\n  font-size: 2rem;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.6);\n  font-style: italic;\n}\n\n/* --- Options Grid --- */\n.options-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  width: 100%;\n}\n\n.option-btn {\n  padding: 20px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.07);\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.option-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-2px);\n  border-color: rgba(255, 255, 255, 0.3);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.option-btn:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.option-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* --- Start Button --- */\n.start-btn {\n  grid-column: span 2;\n  padding: 18px;\n  font-size: 1.25rem;\n  font-weight: 800;\n  letter-spacing: 1px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.4);\n}\n\n.start-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6);\n  filter: brightness(1.1);\n}\n\n.start-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n/* --- Lobby & Cards --- */\n.match-card {\n  transition: all 0.3s ease !important;\n}\n\n.match-card:hover {\n  border-color: rgba(139, 92, 246, 0.4) !important;\n  background: rgba(139, 92, 246, 0.05) !important;\n}\n\n.round-summary {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 12px;\n  padding: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.round-summary h3 {\n  margin: 0 0 10px 0;\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Responsive Tweaks */\n@media (max-width: 480px) {\n  .prompt-word {\n    font-size: 2.5rem;\n  }\n  \n  .option-btn {\n    padding: 16px;\n    font-size: 1rem;\n  }\n}\n\n/* Match Page Overrides for Flappy classes to fit Reaction */\n.flappy-page.reaction-duel {\n  background: radial-gradient(1200px 700px at 20% 10%, rgba(139, 92, 246, 0.15), transparent 55%),\n              radial-gradient(900px 600px at 90% 0%, rgba(59, 130, 246, 0.15), transparent 55%),\n              #060912;\n}\n\n.flappy-card h2 {\n    color: #a78bfa;\n}\n\n/* Lobby Styling */\n.reaction-lobby {\n    background: radial-gradient(1200px 700px at 80% 90%, rgba(139, 92, 246, 0.12), transparent 55%),\n                radial-gradient(900px 600px at 10% 10%, rgba(59, 130, 246, 0.12), transparent 55%),\n                #080b16 !important;\n}\n\n.reaction-lobby .page-title {\n    color: #a78bfa !important;\n    text-shadow: 0 0 15px rgba(167, 139, 250, 0.3) !important;\n}\n\n/* Player Badges & Stats */\n.player-badge {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 14px;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n}\n\n.player-name {\n    font-weight: 700;\n    color: #fff;\n    font-size: 0.95rem;\n}\n\n.cm-player-stat {\n    padding: 2px 8px;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\n.cm-player-stat--rating {\n    background: rgba(59, 130, 246, 0.2);\n    color: #60a5fa;\n}\n\n.cm-player-stat--streak {\n    background: rgba(234, 179, 8, 0.2);\n    color: #facc15;\n}\n\n/* Background Orbs Animation */\n.animated-bg {\n    position: fixed;\n    inset: 0;\n    z-index: -1;\n    overflow: hidden;\n    pointer-events: none;\n}\n\n.gradient-orb {\n    position: absolute;\n    border-radius: 50%;\n    filter: blur(80px);\n    opacity: 0.4;\n}\n\n.orb-1 {\n    width: 400px;\n    height: 400px;\n    background: #4f46e5;\n    top: -100px;\n    left: -100px;\n}\n\n.orb-2 {\n    width: 300px;\n    height: 300px;\n    background: #7c3aed;\n    bottom: 50px;\n    right: -50px;\n}\n\n.orb-3 {\n    width: 250px;\n    height: 250px;\n    background: #db2777;\n    top: 40%;\n    left: 70%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
